import { PaginationComponent } from "@/components";
import CommonTableActions from "@/components/common/CommonTableActions";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useGroupUIPermissionCheck } from "@/lib/hooks";
import {
  getDateTableField,
  getImageTableField,
  getTextTableField,
} from "@/utils/helper-functions";
import React, { useMemo } from "react";

const CommonListingTable = ({
  userId,
  data = [],
  paginationDetails,
  tableColumns = [],
  tableRowsFields = [],
  permissionItems = {},
  actionFunctions = {},
  actionTypes = {},
  editRoute = "#",
  extraEditSearchParams = "",
  deleteTargetType = "",
  deletedItemFieldName = "",
  adminRole,
  permissionsList,
}) => {
  const columns = useMemo(() => tableColumns, []);

  return (
    <>
      <div className="mx-3 mt-3 border rounded-sm dark:border-[#fff]/10">
        <Table>
          <TableHeader>
            <TableRow>
              {columns.map((column, index) => {
                if (
                  useGroupUIPermissionCheck(
                    adminRole,
                    permissionsList,
                    column.requirePermissionList
                  )
                ) {
                  return (
                    <TableHead
                      key={`${column.name}-${index + 1}`}
                      className={`${column.class} font-poppins-md text-[11px] sm:text-[13px] text-dark-weight-600 dark:text-light-weight-800`}
                    >
                      {column.name}
                    </TableHead>
                  );
                }
              })}
            </TableRow>
          </TableHeader>

          <TableBody className="font-poppins-rg text-[11px] sm:text-[13px] text-dark-weight-400 dark:text-light-weight-450">
            {data.map((item, index) => {
              const serialNumber = paginationDetails
                ? parseInt(paginationDetails.currentLimit) *
                    (parseInt(paginationDetails.currentPage) - 1) +
                  index +
                  1
                : 0;

              return (
                <TableRow
                  key={item?._id || index}
                  className={`${index === data.length - 1 ? "border-0" : "border-b dark:border-[#fff]/10"}`}
                >
                  {paginationDetails && (
                    <TableCell className={`font-poppins-md`}>
                      {serialNumber}
                    </TableCell>
                  )}

                  {tableRowsFields.map((field, i) => (
                    <React.Fragment key={`field-${i + 1}`}>
                      {field.type === "DATE" &&
                        getDateTableField(
                          item,
                          "status",
                          field.keyName,
                          "text-center"
                        )}

                      {field.type === "IMAGE" &&
                        getImageTableField(
                          item,
                          "status",
                          field.keyName,
                          "flex justify-center items-center"
                        )}

                      {field.type === "TEXT" &&
                        getTextTableField(
                          item,
                          "status",
                          field.keyName,
                          "text-center"
                        )}
                    </React.Fragment>
                  ))}

                  {/* Actions */}
                  <TableCell className="text-right">
                    {useGroupUIPermissionCheck(adminRole, permissionsList, [
                      permissionItems.editItem,
                      permissionItems.deleteItem,
                      permissionItems.toggleActiveItem,
                      permissionItems.toggleFeaturedItem,
                    ]) && (
                      <CommonTableActions
                        actions={actionTypes}
                        editRoute={
                          extraEditSearchParams
                            ? `${editRoute}/${item?._id || ""}${extraEditSearchParams}`
                            : `${editRoute}/${item?._id || ""}`
                        }
                        targetType={deleteTargetType}
                        targetName={item?.[deletedItemFieldName] || ""}
                        deleteArgs={[userId, item?._id || ""]}
                        toggleActiveArgs={[
                          userId,
                          item?._id || "",
                          item?.status || false,
                        ]}
                        toggleFeaturedArgs={[
                          userId,
                          item?._id || "",
                          item?.featured || false,
                        ]}
                        activeStatus={item?.status || false}
                        featuredStatus={item?.featured || false}
                        actionFunctions={actionFunctions}
                        permissionItems={permissionItems}
                        adminRole={adminRole}
                        permissionsList={permissionsList}
                      />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>

      {paginationDetails.totalItemsCount > paginationDetails.currentLimit && (
        <div className="mt-5 px-3 flex items-center gap-2">
          <PaginationComponent paginationDetails={paginationDetails} />
        </div>
      )}
    </>
  );
};

export default CommonListingTable;
